export const CHECKOUT_URL =
  'https://pay.hotmart.com/I107312371O?checkoutMode=10&bid=1787773315893'
